import { fillAssetFinanceFinanceProposal } from '__core/shared/util/salestrekker';
import template from './financeProposal.template.html';

export default {
  template,
  bindings: {
    formName: '<',
    assetDetails: '<',
    financeProposal: '<',
    compareProducts: '<',
    lenders: '<',
    documents: '<',
    additionalProduct: '<',
    contacts: '<',
    income: '<',
    expenses: '<',
    assets: '<',
    liabilities: '<',
    ticketClientTypes: '<',
    workflow: '<',
    objectives: '<',
    ticket: '<',
    settlementDate: '<',
    isCommercial: '<',
    showPreliminaryAssessment: '<',
    isDealOwnerBroker: '<',
    isQuickTool: '<',
    isTicketSettled: '<',
    onShow: '&',
    onFinished: '&'
  },
  controller: class controller {
    constructor(
      $rootScope,
      $timeout,
      $mdUtil,
      $mdMedia,
      $mdMenu,
      $mdDialog,
      eventService,
      dateTimeService,
      helperService,
      assetFinanceService,
      financesService
    ) {
      'ngInject';

      const ctrl = this;
      ctrl.mdMedia = $mdMedia;
      ctrl.mdMenu = $mdMenu;
      ctrl.currentOrganization = $rootScope.CurrentOrganization;
      ctrl.currentTimeZone = $rootScope.CurrentTimeZone();
      ctrl.currentLocale = $rootScope.CurrentLocale();
      ctrl.currentDateFormat = $rootScope.CurrentDateFormatPrimary();
      ctrl.currentCurrency = $rootScope.CurrentCurrency();
      ctrl.organizationCountry = '';
      ctrl.organizationVat = 0;
      ctrl.availableTermInMonths = [];
      ctrl.availableProductTypes = [];
      ctrl.availableAssetFinanceProposalAssociatedFeeTypes = [];
      ctrl.availableAssetTypes = [];
      ctrl.availablePaymentFrequencies = [];
      ctrl.productFeeTypeRelations = [];
      ctrl.isProcessing = false;
      ctrl.isReady = false;

      ctrl.initialize = () => {
        ctrl.organizationCountry = helperService.getOrganizationCountry().name;
        ctrl.organizationVat = helperService.getOrganizationVat();
        ctrl.availableTermInMonths = helperService.getAvailableTermInMonths({
          isRegular: true
        });
        ctrl.assetDetails = ctrl.assetDetails || [];
        ctrl.financeProposal = ctrl.financeProposal || null;
        ctrl.compareProducts = ctrl.compareProducts || [];
        ctrl.lenders = ctrl.lenders || [];
        ctrl.documents = ctrl.documents || [];
        ctrl.additionalProduct = ctrl.additionalProduct || {};
        ctrl.contacts = ctrl.contacts || [];
        ctrl.income = ctrl.income || [];
        ctrl.expenses = _.filter(ctrl.expenses || [], (e) => e?.id && _.isUuid(e?.id));
        ctrl.assets = ctrl.assets || [];
        ctrl.liabilities = ctrl.liabilities || [];
        ctrl.ticketClientTypes = ctrl.ticketClientTypes || [];
        ctrl.workflow = ctrl.workflow || {};
        ctrl.objectives = ctrl.objectives || {};
        ctrl.ticket = ctrl.ticket || {};
        ctrl.ticketDate =
          ctrl.ticket?.values?.onceOffDueDate || ctrl.settlementDate || dateTimeService.epoch();
        ctrl.isCommercial = ctrl.isCommercial || false;
        ctrl.isQuickTool = ctrl.isQuickTool || false;
        ctrl.showPreliminaryAssessment = ctrl.showPreliminaryAssessment || false;
        ctrl.isDealOwnerBroker = ctrl.isDealOwnerBroker || false;
        ctrl.isTicketSettled = ctrl.isTicketSettled || false;
        ctrl.setAvailableProductTypes();
        ctrl.availableAssetTypes = assetFinanceService.getAvailableAssetTypes(
          ctrl.isCommercial,
          false
        );
        ctrl.availablePaymentFrequencies = helperService.getAvailablePaymentFrequencies({
          workflow: ctrl.workflow,
          loanPurpose: ctrl.isCommercial ? 'commercial' : 'consumer'
        });
        ctrl.preferredProduct = assetFinanceService.getPreferredProduct(ctrl.compareProducts);
        ctrl.availableAssetFinanceProposalAssociatedFeeTypes =
          assetFinanceService.getAvailableAssetFinanceAssociatedFeeTypes({
            isQuickTool: ctrl.isQuickTool
          });
        ctrl.productFeeTypeRelations = helperService.getProductFeeTypeRelations();
        if (!ctrl?.financeProposal?.isEdit) {
          ctrl.getSetFinanceProposal();
        }
        ctrl.decimalPlaces = ctrl.isQuickTool ? 4 : 2;
        ctrl.isReady = true;
      };

      ctrl.showEditableFields = () => {
        if (!ctrl.financeProposal?.isEdit) {
          return assetFinanceService.showEditableFields({
            product: ctrl.preferredProduct,
            financeProposal: ctrl.financeProposal
          });
        }
        return true;
      };

      ctrl.setAvailableProductTypes = () => {
        ctrl.availableProductTypes = assetFinanceService.getAvailableProductTypes({
          isCommercial: ctrl.isCommercial,
          isQuickTool: ctrl.isQuickTool
        });
      };

      ctrl.getSetFinanceProposal = () => {
        if (ctrl?.preferredProduct?.productDetails) {
          ctrl.financeProposal = fillAssetFinanceFinanceProposal(
            ctrl.financeProposal,
            ctrl.preferredProduct
          );
          ctrl.financeProposal =
            assetFinanceService.prepareFinanceProposalAmortizationSchedules({
              financeProposal: ctrl?.financeProposal,
              ticketDate: ctrl.ticketDate
            });
        }
        if (ctrl.showEditableFields() && ctrl.isQuickTool) {
          ctrl.financeProposal.isEdit = true;
        }
        ctrl.toggleFinanceProposalAssociatedFees(true);
      };

      ctrl.toggleFinanceProposalEdit = () => {
        $timeout(() => {
          if (!ctrl.financeProposal?.isEdit) {
            ctrl.financeProposal.isNetAmountFinancedEdited =
              ctrl?.preferredProduct?.productDetails?.isNetAmountFinancedEdited || false;
            ctrl.financeProposal.isRateDiscountEdited =
              ctrl?.preferredProduct?.productDetails?.isRateDiscountEdited || false;
            ctrl.getSetFinanceProposal();
          } else {
            ctrl.financeProposal.isNetAmountFinancedEdited = true;
            ctrl.financeProposal.isRateDiscountEdited = true;
            ctrl.financeProposalChanges({});
          }
        });
      };

      ctrl.toggleFinanceProposalAssociatedFees = (isSilent) => {
        if (!ctrl.financeProposal.isAssociatedFeesEdited) {
          ctrl.financeProposal.associatedFees =
            assetFinanceService.setFinanceProposalAssociatedFees({
              associatedFees: ctrl.financeProposal?.associatedFees || [],
              preferredProduct: ctrl.preferredProduct || {},
              isQuickTool: ctrl.isQuickTool
            });
        }
        if (isSilent) {
          ctrl.saveFinanceProposal(true);
        } else {
          ctrl.financeProposalChanges({});
        }
      };

      ctrl.getAssetTypeNames = () => {
        const assets = [];
        for (let i = 0; i < ctrl.assetDetails.length; i += 1) {
          const asset = ctrl.availableAssetTypes.find(
            (a) => ctrl.assetDetails[i].type === a.id
          );
          assets.push(asset !== undefined ? asset.value : 'N/A');
        }
        return assets.join(', ');
      };

      ctrl.isLeaseSelectedAsProductType = () =>
        assetFinanceService.isLeaseSelectedAsProductType({
          item: ctrl.financeProposal
        });

      ctrl.amortizationScheduleEdit = ($event) => {
        eventService.assetFinanceProposalAmortizationScheduleChange({
          event: $event,
          contacts: ctrl.contacts,
          financeProposal: angular.copy(ctrl.financeProposal),
          ticket: ctrl.ticket,
          ticketDate: ctrl.ticketDate,
          isCommercial: ctrl.isCommercial,
          isQuickTool: ctrl.isQuickTool
        });
      };

      ctrl.saveAmortizationSchedule = (financeProposal) => {
        ctrl.financeProposal = financeProposal;
        ctrl.saveFinanceProposal(true);
      };

      ctrl.financeProposalAssociatedFeeAdd = ({ feeType }) => {
        ctrl.financeProposal.associatedFees =
          assetFinanceService.financeProposalAssociatedFeeAdd({
            associatedFees: ctrl.financeProposal.associatedFees,
            feeType,
            showToast: true
          });
      };

      ctrl.financeProposalAssociatedFeeDelete = (idx) => {
        const associatedFee = ctrl.financeProposal.associatedFees[idx];
        if (associatedFee.isCapitalised) {
          ctrl.financeProposal.netAmountFinanced -= helperService.isNumber(
            associatedFee.amount,
            false
          );
        }
        if (ctrl.isQuickTool) {
          ctrl.financeProposal.associatedFees.splice(idx, 1);
        } else {
          helperService
            .deleteItem(
              ctrl.financeProposal.associatedFees,
              ctrl.financeProposal.associatedFees[idx],
              ctrl.financeProposal.associatedFees[idx].getName(),
              'Associated fee'
            )
            .then((result) => {
              if (result) {
                ctrl.financeProposalChanges({});
              }
            });
        }
      };

      ctrl.getLender = (idLender) => _.find(ctrl.lenders, (l) => l.id === idLender);

      ctrl.getUpfrontFee = () =>
        assetFinanceService.getUpfrontFee(
          ctrl.preferredProduct?.selectedProduct || {},
          ctrl.financeProposal?.associatedFees || []
        );

      ctrl.getMonthlyFee = () => assetFinanceService.getMonthlyFee(ctrl.preferredProduct);

      ctrl.showWarning = () =>
        (ctrl.isQuickTool && !ctrl.financeProposal.grossCost) ||
        !ctrl.financeProposal.netAmountFinanced ||
        !ctrl.financeProposal.term ||
        !ctrl.financeProposal.interestRate;

      ctrl.showSection = () => {
        ctrl.onShow({ section: 'assetDetails' });
      };

      ctrl.isMacqSelectedAsLenderAndFeeTypeMarkedAsPpsr = ({ feeType }) =>
        assetFinanceService.isMacqSelectedAsLenderAndFeeTypeMarkedAsPpsr({
          product: ctrl.preferredProduct,
          feeType
        });

      ctrl.getBrokerCommissionLabelName = ({ isPercent }) => {
        let labelName = `Broker commission ${isPercent ? 'percent' : 'value'} (net of GST)`;
        if (ctrl.preferredProduct?.selectedProduct?.assetFinance?.brokerCommission === 4) {
          labelName = `Broker commission ${isPercent ? 'percent' : 'value'} (including GST)`;
        }
        if (
          assetFinanceService.isProductTypeLeaseAndAnzLender({ product: ctrl.preferredProduct })
        ) {
          labelName = `Broker commission ${isPercent ? 'percent' : 'value'}`;
        }
        return labelName;
      };

      ctrl.brokerCommissionCase = ({ field }) => {
        if (!ctrl.financeProposal?.isEdit && field === 'rateDiscount') {
          return (
            ctrl.preferredProduct?.selectedProduct?.assetFinance?.brokerCommission !== 1 &&
            ctrl.preferredProduct?.selectedProduct?.assetFinance?.brokerCommission !== 4 &&
            ctrl.preferredProduct?.selectedProduct?.assetFinance?.brokerCommission !== 6 &&
            ctrl.preferredProduct?.selectedProduct?.assetFinance?.brokerCommission !== 10
          );
        }
        if (!ctrl.financeProposal?.isEdit && field === 'brokerCommissionValue') {
          return (
            !ctrl.isCommercial &&
            ctrl.preferredProduct?.selectedProduct?.assetFinance?.brokerCommission !== 1 &&
            ctrl.preferredProduct?.selectedProduct?.assetFinance?.brokerCommission !== 4 &&
            ctrl.preferredProduct?.selectedProduct?.assetFinance?.brokerCommission !== 6 &&
            ctrl.preferredProduct?.selectedProduct?.assetFinance?.brokerCommission !== 10
          );
        }
        return field === 'rateDiscount' || false;
      };

      ctrl.isBrokerOriginationFeeDisabled = () =>
        (ctrl.preferredProduct?.selectedProduct?.assetFinance?.brokerCommission === 8 ||
          ctrl.preferredProduct?.selectedProduct?.assetFinance?.brokerCommission === 9 ||
          ctrl.preferredProduct?.selectedProduct?.assetFinance?.brokerCommission === 10 ||
          ctrl.preferredProduct?.selectedProduct?.assetFinance?.brokerCommission === 11) &&
        !ctrl.preferredProduct?.productDetails?.isUpfrontFeeCapitalised;

      ctrl.showProcessingAndBrokerFees = () =>
        !ctrl.isCommercial && ($rootScope.isDev() || $rootScope.isPtf() || $rootScope.isNlg());

      ctrl.assetFinanceFinanceProposalEstimate = () => {
        ctrl.isProcessing = true;
        if (!ctrl.showWarning()) {
          if (ctrl.isQuickTool || !ctrl.ticket?.id) {
            ctrl.financeProposal.totalAssetCost = ctrl.financeProposal?.grossCost || 0;
            ctrl.financeProposal.loanAmount = ctrl.financeProposal?.netAmountFinanced || 0;
            ctrl.financeProposalParams = {
              financeProposal: ctrl.financeProposal,
              isCommercial: ctrl.isCommercial
            };
          }

          financesService
            .assetFinanceFinanceProposal({
              idTicket: ctrl.ticket?.id || '',
              financeProposalParams: ctrl.financeProposalParams,
              isQuote: ctrl.isQuickTool
            })
            .then((res) => {
              if (res?.status) {
                ctrl.financeProposal = fillAssetFinanceFinanceProposal(
                  ctrl.financeProposal,
                  res.financeProposal,
                  true
                );
                ctrl.financeProposal =
                  assetFinanceService.prepareFinanceProposalAmortizationSchedules({
                    financeProposal: ctrl?.financeProposal,
                    ticketDate: ctrl.ticketDate
                  });
              }
              ctrl.isProcessing = false;
            });
        } else {
          ctrl.isProcessing = false;
        }
      };

      ctrl.financeProposalChanges = ({ action }) => {
        if (ctrl.financeProposal?.isEdit && ctrl.isQuickTool) {
          switch (action) {
            case 'changeBalloonPercent':
              ctrl.financeProposal.balloonValue = assetFinanceService.setValueOrPercent({
                amount: ctrl.financeProposal?.grossCost || 0,
                percent: ctrl.financeProposal?.balloonPercent || 0
              });
              break;
            case 'changeBalloonValue':
              ctrl.financeProposal.balloonPercent = assetFinanceService.setValueOrPercent({
                amount: ctrl.financeProposal?.grossCost || 0,
                value: ctrl.financeProposal?.balloonValue || 0
              });
              break;
            case 'changeBrokerCommissionPercent':
              ctrl.financeProposal.brokerCommissionValue =
                assetFinanceService.setValueOrPercent({
                  amount: ctrl.financeProposal?.netAmountFinanced || 0,
                  percent: ctrl.financeProposal?.brokerCommissionPercent || 0
                });
              break;
            case 'changeBrokerCommissionValue':
              ctrl.financeProposal.brokerCommissionPercent =
                assetFinanceService.setValueOrPercent({
                  amount: ctrl.financeProposal?.netAmountFinanced || 0,
                  value: ctrl.financeProposal?.brokerCommissionValue || 0
                });
              break;
            case 'changeNetAmountFinanced':
              ctrl.financeProposal.lvr = assetFinanceService.setLvrLvt({
                amount: ctrl.financeProposal?.netAmountFinanced || 0,
                total: ctrl.financeProposal?.grossCost || 0
              });
              if (ctrl.isCommercial) {
                ctrl.financeProposal.brokerCommissionValue =
                  assetFinanceService.setValueOrPercent({
                    amount: ctrl.financeProposal?.netAmountFinanced || 0,
                    percent: ctrl.financeProposal?.brokerCommissionPercent || 0
                  });
              }
              break;
            case 'changeLvr':
              ctrl.financeProposal.netAmountFinanced =
                ctrl.financeProposal?.lvr && ctrl.financeProposal?.grossCost
                  ? _.subtract(
                      _.multiply(
                        _.divide(ctrl.financeProposal.lvr, 100),
                        ctrl.financeProposal.grossCost
                      ),
                      ctrl.financeProposal?.brokerCommissionValue || 0
                    )
                  : 0;
              if (ctrl.isCommercial) {
                ctrl.financeProposal.brokerCommissionValue =
                  assetFinanceService.setValueOrPercent({
                    amount: ctrl.financeProposal?.netAmountFinanced || 0,
                    percent: ctrl.financeProposal?.brokerCommissionPercent || 0
                  });
              }
              break;
            default:
              break;
          }
        }
        let isSilent = false;
        if (ctrl.financeProposal?.isEdit && !ctrl.isQuickTool) {
          isSilent = true;
        }
        ctrl.fPChanges(isSilent);
      };

      ctrl.fPChanges = _.debounce((isSilent) => {
        ctrl.saveFinanceProposal(isSilent);
      }, 3000);

      ctrl.saveFinanceProposal = (isSilent) => {
        const data = {
          financeProposal: ctrl.financeProposal,
          aFCD: !isSilent ? 'assetFinanceFinanceProposal' : ''
        };
        ctrl.onFinished({ data });
      };

      ctrl.destroyWatch = eventService.onChangedData((params) => {
        if (params?.changedData === 'assetFinanceFinanceProposal') {
          ctrl.assetFinanceFinanceProposalEstimate();
        } else {
          ctrl.isProcessing = false;
        }
      });

      ctrl.$onInit = () => {
        ctrl.initialize();
      };

      ctrl.$onChanges = (changes) => {
        if (changes.settlementDate && changes.settlementDate.currentValue) {
          ctrl.initialize();
        }
      };

      ctrl.$onDestroy = () => {
        ctrl.destroyWatch();
      };
    }
  }
};
